const en = {
  language: "en",
  header: {
    nav: {
      home: "Home",
      about_us: "About us",
      services: "Services",
      feedback: "Contacts"
    }
  },
  footer: {
    copyright: "techproengineering © 2022"
  },
  videoBg: {
    list: [
      "Metal laser cutting"
    ],
    btnText: "Our Services"
  },
  aboutUs: {
    title: "About Us",
    subtitle1: "We are - Tech",
    subtitle2: "Pro",
    subtitle3: "Engineering",
    text: "Young professionals in a wide range of services",
    btnText: "Learn more",
    title2: "We have various types of equipment available:",
    servicesList: [
      {
        title: "Metal laser cutting nachine"
      },
      {
        title: "Park of optical fiber and CO2 engraving lasers",
        subtitle: "(Works on various metals, wood, leather, glass, etc.)"
      },
      {
        title: "Equipment for powder coating",
        subtitle: "(We carry out painting from discs to various parts)"
      },
      {
        title: "Grinding details"
      },
      {
        title: "Glass and sandblasting chambers"
      },
      {
        title: "UV printer",
        subtitle: "(Printing is possible on any details and at all 360 degrees)"
      },
      {
        title: "Ultrasonic bath for cleaning various surfaces"
      }
    ],
    text2: `The use of state-of-the-art equipment and the latest developments allows us to fulfill various orders very efficiently and quickly. A wide range of equipment enables the production of various products and parts. We also work with serial orders of any complexity to meet the needs of our customers in various industries. We do not limit ourselves to standard positions, we are ready for creative cooperation. You can get acquainted with our works on social media.`,
    title3: "Do you have any questions?",
    subtitle_3: "Please contact us for contact details, we will be happy to consult you!",
    btnText2: "Our contacts"
  },
  services: {
    title: "Our Services",
    list: [
      {
        id: "1",
        url: "lazerna-porizka",
        helmet: {
          title: "CNC laser cutting Rivne, TechPro laser cutting of metals",
          metaContent: "CNC laser cutting of metals, stainless steel, leather, plastic, plywood and other non-metals in Rivne and with delivery across Ukraine from Tech Pro Engineering."
        },
        title: "Laser cutting of metals and other materials",
        mediaType: "video",
        content: [
          "One of the directions of our work is laser cutting of metals and other materials. This service includes sheet cutting of stainless steel and other rough metals.",
          "The technology of such cutting has a number of significant advantages compared to other methods of cutting metal:",
          [
            "- Arbitrary configuration of the part: the geometric shape of the parts and the level of complexity of the contour of the product are actually limited only by the imagination of the designer or designer;",
            "- High-quality cut surface, absence of residual deformation on the parts (computerization of the process and lack of mechanical influence allows avoiding residual deformation of the contours of the cut, as well as minimizing temporary deformations;",
            "- Speed and automation of the laser cutting process;",
            "- High precision of the equipment for laser cutting (there is no need for further mechanical adjustment of the part to the given dimensions);"
          ],
          "Production parameters of our machine: ",
          "- We cut with nitrogen and air;",
          "- Steel up to 16 mm;",
          "- Stainless steel up to 8 mm;",
          "- Table working area 3000 x 1500 mm;",
          "- Cutting accuracy +- 0.1mm;",
          "Another direction of our work is the cutting of non-metallic materials, which includes the cutting of foam rubber, leather, acrylic, plastic, plywood, etc.",
          "TechProEngineering provides laser cutting services for metal, leather, plywood and other materials in city Sarny, Rivne region and with delivery throughout Ukraine."
        ],
        feedbackText1: "The cost of the laser cutting service is calculated individually. You can use our ",
        feedbackLink: "feedback form",
        feedbackText2: " and send us information for calculation, indicating the type of cutting and material you are interested in. Our manager will definitely contact you.",
        phoneText: "You can contact us by phone:",
        emailText: "Email for sending drawings:"
      },
      {
        id: "2",
        url: "lazerne-graviyuvanya",
        helmet: {
          title: "Laser engraving, application of text, images, logos on metals and non-metals TechPro Rivne",
          metaContent: "example contentDecorative laser engraving, high-quality application of information, text, image, logo on metal, stainless steel, leather, rubber, ceramics, glass. Fast and high-quality laser engraving in the Rivne region and with delivery across Ukraine from Tech Pro Engineering."
        },
        title: "Laser engraving",
        mediaType: "image",
        content: [
          "The main activity of our company is the provision of laser engraving services on metals and non-metals.",
          "A wide range of laser engraving equipment allows us to apply any information in the form of text, images or logos on metal, plastic, leather, wood, ceramics, rubber, fabric, glass, etc. and quickly and efficiently process large bulk orders.",
          "The image obtained by laser engraving is characterized by durability and wear resistance, and thanks to the high controllability of the processing processes, it is possible to obtain both light surface marking and deep laser engraving. Laser engravers have found wide application in souvenir and advertising products, as well as in manufacturing enterprises.",
          "TechProEngineering provides laser engraving services for metal, leather, ceramics, stainless steel and other materials in city Sarny, Rivne region and with delivery throughout Ukraine.",
          "The cost of the laser engraving service is calculated individually."
        ],
        feedbackText1: "You can use our ",
        feedbackLink: "feedback form",
        feedbackText2: " and send us information for calculation, indicating the type of cutting and material you are interested in. Our manager will definitely contact you.",
        phoneText: "You can contact us by phone:",
        emailText: "Email for sending drawings:"
      },
      {
        id: "3",
        url: "poroshkove-farbuvanya",
        helmet: {
          title: "Industrial painting, powder painting of disks, metals in Rivne, TechPro",
          metaContent: "A wide range of colors and special effects of powder coating of discs, metal, equipment in the Rivne region and with delivery across Ukraine from Tech Pro Engineering."
        },
        title: "Powder coating",
        mediaType: "video",
        content: [
          "Industrial painting, carried out by the method of powder painting, is one of the many directions of our activity. In particular, the main specialization of this type of service is the painting of car rims.",
          "Powder painting is carried out with the help of electrostatic sprinkling of charged particles of powder on the metal surface. During heat treatment in the oven, at a temperature of 180-220C, the powder paint melts and a solid layer is formed - a polymer coating.",
          "After painting, the surface of the product acquires characteristics that cannot be achieved using conventional technologies:",
          [
            "- Atmospheric resistance and resistance to ultraviolet rays;",
            "- Chemical resistance to solutions of many acids, alkalis, petroleum products and some organic solvents;",
            "- High strength, impact resistance, elasticity;",
            "- A wide range of colors and special effects, combining protective and decorative properties."
          ],
          "Dimensions of our powder chamber: 1500x1000x1000 cm.",
          "We get the best result of painting by carrying out preliminary technological treatment of the surface. At the enterprise, you can choose the necessary process that will allow you to prepare the products for painting as much as possible.",
          "TechProEngineering provides services of high-quality powder coating of car rims and other metals in the city Sarny, Rivne region and with delivery throughout the territory of Ukraine.",
          "The cost of the powder painting service is calculated individually."
        ],
        phoneText: "For all questions, contact us by phone, our managers will be happy to help you:",
        emailText: "Email:"
      },
      {
        id: "4",
        url: "sklostrumeneva-piskostrumenneva-obrobka",
        helmet: {
          title: "Glass-blasting and sandblasting of metal TechPro Rivne",
          metaContent: "Delicate cleaning and grinding of metal, glass-blasting and sandblasting without damage to carvings and surfaces in the city Sarny, Rivne region and with delivery across Ukraine from Tech Pro Engineering."
        },
        title: "Glass-blasting and sandblasting",
        mediaType: "image",
        content: [
          "We offer glass-blasting and sandblasting services, which are one of the finishing treatments for the surfaces of metal parts. The essence of glass-blasting is the bombardment of the treated surface with glass balls of different diameters, which results in a matte, uniform surface. In addition to the treatment of metal surfaces, glass-blasting is used for the treatment of glass, stone, plastic, etc.",
          "The delicacy of this treatment allows you to clean the materials without damaging the threads and landing surfaces.",
          "Sandblasting of metal is a method of cleaning metal surfaces with an abrasive flow that acts as a grinding agent. This process has a double function: it cleans the surface and gives it roughness.",
          "You can independently choose the type of processing that interests you the most and contact us.",
          "TechProEngineering provides services of glass-blasting and sandblasting of parts, metal surfaces in the city Sarny, Rivne region and with delivery throughout Ukraine."
        ],
        phoneText: "For all questions, contact us by phone, our managers will be happy to help you:",
        emailText: "Email:"
      },
      {
        id: "5",
        url: "shlifuvanya-turbogaltuvanya",
        helmet: {
          title: "High-precision metal machining, grinding, turbohalting, laser cutting and engraving TechPro Rivne",
          metaContent: "Complex high-precision metalworking in the city Sarny, Rivne region, centerless grinding and polishing of metals, turbo-halting of metal products in the Rivne region and with delivery across Ukraine from Tech Pro Engineering."
        },
        title: "Grinding and turbohalting",
        mediaType: "video",
        content: [
          "Our company also provides services for centerless grinding and polishing of metal products. This method has fairly high efficiency and high processing accuracy. Centerless grinding, performed without a clamp and without devices for forced rotation of the part, does not require the creation of central base sockets and simplifies processing automation." ,
          "We provide the following services:",
          [
           "- Grinding of flat surfaces;",
           "- Grinding of cylindrical surfaces."
          ],
          "TECHPRO ENGINEERING also performs felting and polishing of parts made of black and stainless steel, titanium and brass in felting vibrating machines.",
          "The main application is as a finishing treatment of parts made of various metals, as a result of which it is possible to obtain an almost mirror-like surface.",
          "TechProEngineering provides services of metal grinding, turbogalting and polishing of parts in the city of Rivne and with delivery throughout the territory of Ukraine."
        ],
        phoneText: "For all questions, contact us by phone, our managers will be happy to help you:",
        emailText: "Email:"
      },
      {
        id: "6",
        url: "ultrazvukove-ochyschenya",
        helmet: {
          title: "Ultrasonic cleaning of impurities of ani tsomplehiti TechPro Rivne",
          metaContent: "Cleaning of impurities of any complexity, degreasing, decarburization and removal of scale from the most difficult-to-reach places of parts and components in an ultrasonic industrial bath. Ultrasonic cleaning in the Rivne region and with delivery across Ukraine from Tech Pro Engineering."
        },
        title: "Ultrasonic industrial cleaning",
        mediaType: "image",
        content: [
          "Ultrasonic industrial parts cleaning bath is the ultimate degreasing, decarburizing and descaling tool for all parts and components.",
          "Ultrasonic cleaning is the key to achieving the best results even in the most difficult-to-reach places, regardless of their complexity and configuration.",
          "The main advantages of cleaning parts with ultrasound:",
          [
            "- Removal of all types of contamination, including oil, grease, soot, rust, protective enamels and others;",
            "- Fast, effective and thorough cleaning, no mechanical damage or scratches;",
            "- Ultrasound cleaning is safe for all types of materials, does not have a mechanical effect on the surface of the cleaned parts."
          ],
          "TechProEngineering provides services for ultrasonic cleaning of parts from contamination in the city Sarny, Rivne region and with delivery throughout Ukraine."
        ],
        phoneText: "For all questions, contact us by phone, our managers will be happy to help you:",
        emailText: "Email:"
      },
      {
        id: "7",
        url: "ultrafioletovyy-druk",
        helmet: {
          title: "Clear and high-quality UV printing on flat, cylindrical surfaces TechPro Rivne",
          metaContent: "Reliable, clear and high-quality ultraviolet printing on wood, plywood, chipboard, glass, ceramics and other materials. We perform ultraviolet printing on flat, cylindrical surfaces in the Rivne region and with delivery across Ukraine from Tech Pro Engineering."
        },
        title: "UV printing",
        mediaType: "video",
        content: [
          "The unique service we provide is ultraviolet printing. We have a last-generation ultraviolet printer in our fleet with an additional installation, which allows us to apply an extremely clear and high-quality image not only on flat surfaces, but also on cylindrical surfaces at all 360 degrees!",
          "The print does not lose its quality, color, and reliably adheres to almost all materials (wood, plywood, chipboard, MDF, glass, plastic, acrylic, composite, stone, canvas, ceramics).",
          "You can order UV printing on the following surfaces:",
          [
            "- Trees, plywood, chipboard, MDF (tables, wardrobes, kitchen cabinets, signs, etc.);",
            "- Glass (kitchen aprons, doors, stained-glass windows, furniture, interior partitions, etc.);",
            "- Plastics, acrylics, composites (advertising products - stands, showcases, signs, etc.);",
            "- Stones (panels, frescoes, facades of buildings, etc.);",
            "- Wallpapers (photowallpapers of different textures for different types of rooms);",
            "- Canvases (pictures for children's room, office, living room, kitchen);",
            "- Ceramics (tiles, etc.);",
            "- Silicones (phone cases)."
          ],
          "TechProEngineering provides ultraviolet printing services on wood, glass, plastic, silicone and other materials in the city Sarny, Rivne region and with delivery throughout Ukraine."
        ],
        phoneText: "You can contact us by phone:",
        emailText: "Email for sending drawings:"
      }
    ]
  },
  ordering: {
    title: "Order processing",
    btnText: "Order now",
    text1: "Work on the order begins only after discussion and clarification of all details and your wishes.",
    text2: "The terms of the order fulfillment depend on the following factors:",
    list2: [
      "Order type",
      "Production load",
      "Availability of necessary drawings and (or) models"
    ],
    list3: [
      "In turn, we will try to fulfill your order as soon as possible.",
      "If you do not have a layout or drawings, our specialists will help you with this and prepare all the necessary materials for production.",
      "We take orders throughout Ukraine.",
      "DELIVERING is possible by any TRANSPORT COMPANIES."
    ]
  },
  qa: {
    title: "QA",
    questions: [
      {
        title: "How does the ordering process work? ",
        list1: [
          "After contacting our specialists (via e-mail, phone, social networks, etc.), discussing all the details and pre-calculating your order, approving the drawings, making a full prepayment of the order, we transfer all data to production for the fulfillment of your order."
        ]
      },
      {
        title: "How long will it take for my order to be fulfilled?",
        list1: [
          "Terms of order fulfillment depend on the type of work, series, production load, availability of the necessary drawings and models.",
          "In turn, we guarantee quick fulfillment of your order"
        ]
      },
      {
        title: "Is it possible to place an order without ready-made drawings, models, illustrations?",
        list1: [
          "We have a full-time design engineer. For an additional fee, we will create a working drawing and order design for you."
        ]
      },
      {
        title: "How is the delivery?",
        list1: [
          "We deliver orders on the territory of Ukraine: Pickup / Nova Pochta / Bridge Express / Delivery."
        ]
      }
    ]
  },
  socials: {
    title: "Social Media"
  },
  feedback: {
    title: "Feedback",
    subtitle: "To send an email with attached files please follow",
    subtitleLink: "the link",
    btnText: "Send",
    select_files: "Select files",
    inputs: [
      {
        name: "name",
        type: "text",
        placeholder: "Name"
      },
      {
        name: "email",
        type: "email",
        placeholder: "Email"
      },
      {
        name: "phone",
        type: "text",
        placeholder: "Phone Number"
      },
      {
        name: "town",
        type: "text",
        placeholder: "Address"
      },
      {
        name: "service",
        type: "checkbox",
        placeholder: "Services",
        options: [
        "Laser cutting of metals and other materials",
        "Laser engraving",
        "Powder painting",
        "Glassblasting and sandblasting",
        "Grinding and Turbohalting",
        "UV Print"
        ]
      },
      {
        name: "comment",
        type: "textarea",
        placeholder: "Comment"
      }
    ]
  },
  contacts: {
    title: "Contacts",
    list: [
      {
        title: "Phone number",
        href: "tel:+380501000845",
        icon: "icon-phone",
        content: [
          "+38 (050) 100-08-45"
        ]
      },
      {
        title: "Email",
        href: "mailto:support@techproengineering.com.ua",
        icon: "icon-email",
        content: [
          "support@techproengineering.com.ua"
        ]
      },
      {
        title: "Address",
        href: "https://www.google.es/maps/place/%D0%91%D1%94%D0%BB%D0%B3%D0%BE%D1%80%D0%BE%D0%B4%D1%81%D1%8C%D0%BA%D0%B0,+13,+%D0%A1%D0%B0%D1%80%D0%BD%D0%B8,+%D0%A0%D1%96%D0%B2%D0%BD%D0%B5%D0%BD%D1%81%D1%8C%D0%BA%D0%B0+%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C,+%D0%A3%D0%BA%D1%80%D0%B0%D1%97%D0%BD%D0%B0,+34500/@51.3318731,26.6152898,17z/data=!3m1!4b1!4m5!3m4!1s0x4728a291e9b2eeb9:0x72ecc9915fb54029!8m2!3d51.3318731!4d26.6174784",
        icon: "icon-location",
        content: [
          "Ukraine, Rivne Region,",
          "Sarny city, str. Evropeyska, 13"
        ]
      }
    ]
  },
  openCatalog: "Open catalog",
  catalog: "Catalog",
}

export default en
